import EventCompetitorsMapper from './event-competitors-mapper';

const EventCompetitorsModel = {
    mapper: EventCompetitorsMapper,

    away: {
        fieldName: 'w',
        type: Object,
    },

    awayCompetitorId: {
        fieldName: 'a',
        type: String,
    },

    home: {
        fieldName: 'o',
        type: Object,
    },

    homeCompetitorId: {
        fieldName: 'h',
        type: String,
    },
};

export default EventCompetitorsModel;
